import { Box } from "@mui/material";
import React from "react";
import type { StaffingIssue } from "../../utils/autoStaffing";
import { Recommendation } from "../Recommendation/Recommendation";

// Create a memoized Recommendation component
const MemoizedRecommendation = React.memo(Recommendation);

export const RecommendationList = React.memo(
	({ recommendations, commonProps, isActive }: { recommendations: StaffingIssue[]; commonProps: any; isActive: boolean }) => {
		if (!isActive) return null;

		return (
			<Box>
				{recommendations.map((rec: StaffingIssue, index: number) => (
					<MemoizedRecommendation key={`${rec.priority}-${index}`} rec={rec} index={index} {...commonProps} />
				))}
			</Box>
		);
	},
);
